import React, { useContext } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import MyContext from "../../../StoreContext";
import gmail from "./assets/gmail.svg";
import twitter from "./assets/twitter.svg";
import whatsapp from "./assets/whatsapp.svg";
import stepTwo from "./assets/stepTwo.svg";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { trackHotjar } from "../../../helpers/hotjar";

const CustomToggleButton = styled(ToggleButton)`
  width: 250px;
  border-radius: 10px;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.16);
  height: 40px;
  background-color: #f6fbfe;
  border: none;

  &.Mui-selected {
    background-color: #f6fbfe;
    border: 2px solid #181533;
  }
`;

const buttonText = {
  fontSize: "16px",
  fontWeight: "600",
  fontFamily: "Asap",
  color: "#000000",
  lineHeight: "20px",
};

/**
 * Componente que se encarga de mostrar las tres opciones de contacto o
 * canales de comunicacion para los cuales estan las automatizaciones
 * gmail, twitter, whatsapp.
 * Este es el segundo paso del flujo de la automatizacion
 */
const Channels = () => {
  const { channel, updateChannel, updateMessage } = useContext(MyContext);

  const handleChange = (event: any, newSelected: string) => {
    trackHotjar(`[Etapa 2] Ha seleccionado el canal de ${newSelected}`);
    updateChannel(newSelected);
    updateMessage("");
  };

  return (
    <>
      <Stack direction='column' spacing={2}>
        <Grid container>
          <img src={stepTwo} alt='stepTwo' />
        </Grid>
        <Stack direction='column' spacing={3}>
          <CustomToggleButton
            value='gmail'
            onClick={handleChange}
            selected={channel === "gmail"}
          >
            <img src={gmail} alt='gmail' />
            <Typography sx={buttonText} className='toggleMessageButtonText'>
              gmail
            </Typography>
          </CustomToggleButton>
          <CustomToggleButton
            value='twitter'
            onClick={handleChange}
            selected={channel === "twitter"}
          >
            <img src={twitter} alt='twitter' />

            <Typography sx={buttonText} className='toggleMessageButtonText'>
              twitter
            </Typography>
          </CustomToggleButton>
          <CustomToggleButton
            value='whatsapp'
            onClick={handleChange}
            selected={channel === "whatsapp"}
          >
            <img src={whatsapp} alt='whatsapp' />
            <Typography
              style={{ marginLeft: "5px" }}
              sx={buttonText}
              className='toggleMessageButtonText'
            >
              whatsapp
            </Typography>
          </CustomToggleButton>
        </Stack>
      </Stack>
    </>
  );
};

export default Channels;
